import { render } from "./MMaintenance.vue?vue&type=template&id=10734fe2&scoped=true"
import script from "./MMaintenance.vue?vue&type=script&lang=js"
export * from "./MMaintenance.vue?vue&type=script&lang=js"

import "./MMaintenance.vue?vue&type=style&index=0&id=10734fe2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10734fe2"]])

export default __exports__